// src/styles/layoutConstants.ts
// CSS 側の --header-height（design-tokens.css）と同じ値。design-tokens.test.ts が一致を確認する
export const HEADER_HEIGHT = 76;
